require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./registration-event-invitations-c-1-cx-ga-4-kci-a-0-w-cm-ui-4-qm-oa-4.json") })
        }
      }, "path---registration-event-invitations-c-1-cx-ga-4-kci-a-0-w-cm-ui-4-qm-oa-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---registration-event-invitations-c-1-cx-ga-4-kci-a-0-w-cm-ui-4-qm-oa-4!./.cache/json/registration-event-invitations-c-1-cx-ga-4-kci-a-0-w-cm-ui-4-qm-oa-4.json
// module id = 354
// module chunks = 231608221292675